import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';
import { DownloadDetail, TargetTab } from '../../model/download-portal-uris';
import { DownloadPortalUrisService } from './download-portal-uris.service';

@Injectable({
  providedIn: 'root',
})
export class RouteLocatorService {
  private readonly pilotToggleRelevantListUrls = [
    this.urisService.getTabUri(TargetTab.BASE),
  ];
  private readonly pilotToggleRelevantDetailUrls = [
    this.urisService.findRoute(DownloadDetail.BASE_SOFTWARE_DETAIL),
  ];

  private readonly currentRoute$: Observable<string> = this.router.events.pipe(
    startWith(new NavigationEnd(-1, this.router.url, this.router.url)),
    filter(event => event instanceof NavigationEnd),
    map(() => this.router.url),
  );

  public isOnPilotToggleRelevantListPage$: Observable<boolean> =
    this.currentRoute$.pipe(
      map(url =>
        this.pilotToggleRelevantListUrls.some(relevantListUrl =>
          url.includes(relevantListUrl),
        ),
      ),
    );

  public isOnPilotToggleRelevantDetailPage$: Observable<boolean> =
    this.currentRoute$.pipe(
      map(url =>
        this.pilotToggleRelevantDetailUrls
          .map(detailUrl => detailUrl.replace('/:id', ''))
          .some(relevantListUrl => url.includes(relevantListUrl)),
      ),
    );

  public isOnSmeListPage$: Observable<boolean> = this.currentRoute$.pipe(
    map(url => url.includes(this.urisService.getTabUri(TargetTab.SME))),
  );

  public isOnBaseSoftwareListPage$: Observable<boolean> =
    this.currentRoute$.pipe(
      map(url => url.includes(this.urisService.getTabUri(TargetTab.BASE))),
    );

  constructor(
    private readonly router: Router,
    private readonly urisService: DownloadPortalUrisService,
  ) {}
}
